import { Empty } from 'antd';
import { ReactComponent as EmptyStateBoxIcon } from '@features/regional-overview/assets/digital-traps/empty-state-box.svg';
import { ReactComponent as EmptyStateSearchIcon } from '@features/regional-overview/assets/digital-traps/empty-state-search.svg';
import { ReactComponent as EmptyStateSelectIcon } from '@features/regional-overview/assets/components/empty-state-select-items.svg';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DIGITAL_TRAP_EMPTY_STATE } from '../../domain/tests-id.constants';
import { Container, Description, Title } from './empty-state.styles';

interface EmptyStateProps {
  context: 'search' | 'list' | 'flight_curve';
}

export const EmptyState = ({ context }: EmptyStateProps) => {
  const [t] = useTranslation();

  const emptyImage = useMemo(() => {
    switch (context) {
      case 'list':
        return <EmptyStateBoxIcon />;
      case 'flight_curve':
        return <EmptyStateSelectIcon />;
      default:
        return <EmptyStateSearchIcon />;
    }
  }, [context]);

  return (
    <Empty
      image={emptyImage}
      description={
        <Container>
          <Title>{t(`pages.regional_overview.digital_traps.empty_state.${context}_title`)}</Title>
          <Description>{t(`pages.regional_overview.digital_traps.empty_state.${context}_description`)}</Description>
        </Container>
      }
      data-testid={DIGITAL_TRAP_EMPTY_STATE}></Empty>
  );
};
